import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

EmptyView.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string,
};

function EmptyView({ icon = AppResource.images.empty.box, text, title }) {
  // ---- params ----
  const { t } = useTranslation();

  return (
    <div
      className={`d-flex flex-column align-items-center justify-content-center gap-4 h-100 ${
        icon ? 'py-10' : 'py-4'
      }`}
    >
      {icon && <img src={icon} style={{ maxWidth: '250px', maxHeight: '250px' }} />}

      <div className="d-flex flex-column align-items-center gap-2 text-center">
        {!_.isEmpty(title) && (
          <span
            style={{
              fontWeight: '600',
              fontSize: Utils.convertToFontSize(16),
              color: AppColors.gray[800],
            }}
          >
            {title}
          </span>
        )}
        <span
          style={{
            fontWeight: '400',
            fontSize: Utils.convertToFontSize(14),
            color: AppColors.gray[600],
          }}
        >
          {text ?? t('noData')}
        </span>
      </div>
    </div>
  );
}

export default EmptyView;
